import { render, staticRenderFns } from "./toggleswitchexample.vue?vue&type=template&id=4ef937ec&scoped=true&"
import script from "./toggleswitchexample.vue?vue&type=script&lang=js&"
export * from "./toggleswitchexample.vue?vue&type=script&lang=js&"
import style0 from "./toggleswitchexample.vue?vue&type=style&index=0&id=4ef937ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef937ec",
  null
  
)

export default component.exports